(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
class ProductSlider {
  constructor(element) {
    this.slider = element;
    this.track = element.querySelector('.product-slider__track');
    this.slides = Array.from(this.track.children);
    this.nextButton = element.querySelector('.product-slider__nav--next');
    this.prevButton = element.querySelector('.product-slider__nav--prev');
    this.dotsMobile = element.querySelector('.product-slider__dots--mobile');
    this.dotsDesktop = element.querySelector('.product-slider__dots--desktop');
    
    // Get settings from data attributes
    this.settings = {
      autoplay: this.slider.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.slider.dataset.autoplaySpeed),
      infinite: this.slider.dataset.infinite === 'true',
      slidesMobile: parseInt(this.slider.dataset.slidesMobile),
      slidesDesktop: parseInt(this.slider.dataset.slidesDesktop),
      enableDragging: this.slider.dataset.enableDragging === 'true'
    };

    this.currentIndex = 0;
    this.slidesPerView = window.innerWidth >= 768 ? this.settings.slidesDesktop : this.settings.slidesMobile;
    this.maxIndex = Math.ceil(this.slides.length / this.slidesPerView) - 1;

    this.init();
  }

  init() {
    this.setupDots();
    this.setupButtons();
    this.setupAutoplay();
    this.updateSlidePositions();

    window.addEventListener('resize', () => {
      this.slidesPerView = window.innerWidth >= 768 ? this.settings.slidesDesktop : this.settings.slidesMobile;
      this.maxIndex = Math.ceil(this.slides.length / this.slidesPerView) - 1;
      this.updateSlidePositions();
      this.setupDots();
    });

    // Disable dragging for now
    // if (this.settings.enableDragging) {
    //   this.setupDragEvents();
    // }
  }

  setupDots() {
    const dotsCount = this.maxIndex + 1;
    
    [this.dotsMobile, this.dotsDesktop].forEach(dotsContainer => {
      if (!dotsContainer) return;
      
      dotsContainer.innerHTML = '';
      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement('button');
        dot.classList.add('product-slider__dot');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === this.currentIndex) dot.classList.add('active');
        
        dot.addEventListener('click', () => this.goToSlide(i));
        dotsContainer.appendChild(dot);
      }
    });
  }

  setupButtons() {
  // Get ALL next and previous buttons (not just the first one)
  const nextButtons = this.slider.querySelectorAll('.product-slider__nav--next');
  const prevButtons = this.slider.querySelectorAll('.product-slider__nav--prev');
  
  // Add event listeners to all next buttons
  nextButtons.forEach(button => {
    button.addEventListener('click', () => this.next());
  });
  
  // Add event listeners to all previous buttons
  prevButtons.forEach(button => {
    button.addEventListener('click', () => this.prev());
  });
}

  setupAutoplay() {
    if (this.settings.autoplay) {
      this.startAutoplay();
      
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => this.next(), this.settings.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  updateSlidePositions() {
    const offset = -(this.currentIndex * (100 / this.slidesPerView));
    this.track.style.transform = `translateX(${offset}%)`;
  }

  updateDots() {
    [this.dotsMobile, this.dotsDesktop].forEach(dotsContainer => {
      if (!dotsContainer) return;
      
      Array.from(dotsContainer.children).forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    });
  }

  next() {
    if (this.currentIndex >= this.maxIndex) {
      if (this.settings.infinite) {
        this.currentIndex = 0;
      } else {
        return;
      }
    } else {
      this.currentIndex++;
    }
    
    this.updateSlidePositions();
    this.updateDots();
  }

  prev() {
    if (this.currentIndex <= 0) {
      if (this.settings.infinite) {
        this.currentIndex = this.maxIndex;
      } else {
        return;
      }
    } else {
      this.currentIndex--;
    }
    
    this.updateSlidePositions();
    this.updateDots();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlidePositions();
    this.updateDots();
  }

  setupDragEvents() {
    this.track.addEventListener('touchstart', this.onDragStart.bind(this));
    this.track.addEventListener('touchmove', this.onDragMove.bind(this));
    this.track.addEventListener('touchend', this.onDragEnd.bind(this));
    this.track.addEventListener('mousedown', this.onDragStart.bind(this));
    this.track.addEventListener('mousemove', this.onDragMove.bind(this));
    this.track.addEventListener('mouseup', this.onDragEnd.bind(this));
  }
  
  onDragStart(event) {
    if (event.type === 'mousedown' && event.button !== 0) return;

    this.dragStartX = event.clientX || event.touches[0].clientX;
    this.dragging = true;
    this.dragStartIndex = this.currentIndex;
  }

  onDragMove(event) {
    if (!this.dragging) return;
    
    const currentX = event.clientX || event.touches[0].clientX;
    this.dragOffsetX = currentX - this.dragStartX;
    this.track.style.transition = 'none';
    const offset = -(this.currentIndex * (100 / this.slidesPerView)) + (this.dragOffsetX / this.track.clientWidth * 100);
    this.track.style.transform = `translateX(${offset}%)`;
  }

  onDragEnd(event) {
    if (!this.dragging) return;
    
    this.dragging = false;
    this.track.style.transition = 'transform 0.5s ease';
    if (this.dragOffsetX > 50) {
      this.prev();
    } else if (this.dragOffsetX < -50) {
      this.next();
    } else {
      this.resetSlidePosition();
    }
    this.dragOffsetX = 0;
  }

  resetSlidePosition() {
    const offset = -(this.currentIndex * (100 / this.slidesPerView));
    this.track.style.transform = `translateX(${offset}%)`;
  }
  
}

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('[data-slider]');
  sliders.forEach(slider => new ProductSlider(slider));
});

  } catch(e) { console.error(e); }
})();
})();
